document.addEventListener('DOMContentLoaded', () => {
  const socialShareToggleBtn = document.getElementById('social-share-wrapper');
  const pintBtn = document.querySelector("#social-share-buttons .social-button.pinterest");
  const fbBtn = document.querySelector("#social-share-buttons .social-button.facebook");
  if (pintBtn != undefined) {
    pintBtn.addEventListener('touchstart', sharePinterest);
    pintBtn.addEventListener('click', sharePinterest);
  }
  if (fbBtn != undefined) {
    fbBtn.addEventListener('touchstart', shareFacebook);
    fbBtn.addEventListener('click', shareFacebook);
  }
  document.body.addEventListener('click', (e) => {
    let target = e.target;
    let sharePop = document.querySelector('.popup-social-share');

    if (target.getAttribute('id') != null) {
      if (target.getAttribute('id').indexOf('social-share') == -1) {
        sharePop.style.display = "none";
      }
      return false;
    }
    if (!target.classList.contains('social-share')) {
      sharePop.style.display = "none";
    }
    return false;
  });
}, false);

function social_share(_this) {
  let sharePop = document.querySelector('.popup-social-share');
  let coords = _this.getBoundingClientRect();
  var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);

  if (sharePop != undefined) {
    if (sharePop.style.display == "none" || sharePop.style.display.trim().length == 0) {
      sharePop.style.top = coords.top + (isMobile ? window.pageYOffset:0) + coords.height+7+'px';
      sharePop.style.left = ((coords.left + coords.width) - 122)+'px';
      sharePop.style.display = "block";
    } else {
      sharePop.style.display = "none";
    }
  }
}

function sharePinterest(e) {
  e.preventDefault();

  let sharePop = document.querySelector('.popup-social-share');
  const bookmarkletURL = "//pinterest.com/pin/create/bookmarklet/";
  let mediaURL = "";
  
  let productImage = document.querySelector('#product-media-slider-slide01 div img');
  if (productImage != undefined) {
    mediaURL = productImage.getAttribute("src")
  }

  let descriptionEl = document.querySelectorAll('.product-single__description p');
  let descriptionText = "";
  if (descriptionEl != undefined) {
    if (descriptionEl.length > 1) {
      descriptionText = encodeURIComponent(descriptionEl[descriptionEl.length - 1].innerText);
    } else {
      descriptionText = encodeURIComponent(descriptionEl.innerText);
    }
  }
  sharePop.style.display = "none";
  let pinUrl = bookmarkletURL+'?media='+mediaURL+'&url='+socialShareStoreURL+socialShareProductURL+'&description='+descriptionText+'&method=button';
  window.open(pinUrl,'_blank','width=350,height=750,toolbar=0,location=0,directories=0,status=0');
  return false;
}

function shareFacebook(e) {
  let sharePop = document.querySelector('.popup-social-share');
  sharePop.style.display = "none";
  const navUrl = 'https://www.facebook.com/sharer/sharer.php?u='+socialShareStoreURL+socialShareProductURL;
  window.open(navUrl , '_blank','width=350,height=350,toolbar=0,location=0,directories=0,status=0');
}